<template>
  <div class="IncreaseChange">
    <el-dialog
      :title="$attrs.pargam.head===0?'新增':'修改'"
      width="1000px"
      append-to-body
      destroy-on-close
      @close="closeDialog"
      @open="opendialog"
      :visible.sync="visible"
      :show="show"
      :close-on-click-modal="false"
    >
      <div class="IncreaseChange_box">
        <template v-for="(item,index) in pageConfigData.A">
          <Increaseinput
            v-if="item.FillType==0 || item.FillType== 2 || item.FillType==6 || item.FillType==9  "
            :reg="item.FillType==9?'float':'' "
            :isMust="item.Must"
            :placeholder="item.Must?item.Name+'不能为空':''"
            ref="figData"
            :id="'row'+index"
            :icon="item.FillType==0?true:false"
            :key="index"
            :disabled="item.FillType==0?true:false || item.FillType==6?true:false"
            :labelName="item.Name"
            class="sty_rowinputw"
            v-model.lazy="notesVal[item.Key]"
            @ChoiceClick="clickclose(arguments,item.Key,item.FillType)"
            @dateChange="dateChange(arguments,item.Key)"
            @preFocus="upkey(notesVal[item.Key],index,item.FillType)"
            @nextFocus="nextFocus(notesVal[item.Key],index,item.FillType)"
            @clickclose="clickclose(arguments,item.Key,item.FillType)"
            @clicknative="clicknative(index)"
          />
        </template>
        <template v-for="(item,index) in pageConfigData.B">
          <Increaseinput
            v-if="item.FillType==0 || item.FillType== 2 || item.FillType==6 || item.FillType==9  "
            :reg="item.FillType==9?'float':'' "
            :isMust="item.Must"
            :placeholder="item.Must?item.Name+'不能为空':''"
            ref="figData"
            :id="'row'+Number(index)+Number(pageConfigData.A.length)"
            :icon="item.FillType==0?true:false"
            :key="index+pageConfigData.A.length"
            :labelName="item.Name"
            class="sty_rowinputw"
            v-model.lazy="notesVal[item.Key]"
            :disabled="item.FillType==0?true:false || item.FillType==6?true:false"
            @ChoiceClick="clickclose(arguments,item.Key,item.FillType)"
            @dateChange="dateChange(arguments,item.Key,)"
            @preFocus="upkey(notesVal[item.Key],Number(index)+Number(pageConfigData.A.length),item.FillType)"
            @nextFocus="nextFocus(notesVal[item.Key],Number(index)+Number(pageConfigData.A.length),item.FillType)"
            @clickclose="clickclose(arguments,item.Key,item.FillType)"
            @clicknative="clicknative(Number(index)+Number(pageConfigData.A.length))"
          />
        </template>
        <template v-for="(item,index) in pageConfigData.C">
          <Increaseinput
            v-if="item.FillType==0 || item.FillType== 2 || item.FillType==6 || item.FillType==9  "
            :reg="item.FillType==9?'float':'' "
            :isMust="item.Must"
            :placeholder="item.Must?item.Name+'不能为空':''"
            ref="figData"
            :id="'row'+Number(index)+Number(pageConfigData.A.length)+Number(pageConfigData.B.length)"
            :icon="item.FillType==0?true:false"
            :key="index+pageConfigData.A.length+pageConfigData.B.length"
            :labelName="item.Name"
            class="sty_rowinputw"
            v-model.lazy="notesVal[item.Key]"
            :disabled="item.FillType==0?true:false || item.FillType==6?true:false"
            @ChoiceClick="clickclose(arguments,item.Key,item.FillType)"
            @dateChange="dateChange(arguments,item.Key,)"
            @preFocus="upkey(notesVal[item.Key],Number(index)+Number(pageConfigData.A.length)+Number(pageConfigData.B.length),item.FillType)"
            @nextFocus="nextFocus(notesVal[item.Key],Number(index)+Number(pageConfigData.A.length)+Number(pageConfigData.B.length),item.FillType)"
            @clickclose="clickclose(arguments,item.Key,item.FillType)"
            @clicknative="clicknative(Number(index)+Number(pageConfigData.A.length)+Number(pageConfigData.B.length))"
          />
        </template>
      </div>
      <div class="IncreaseChange_box_footer">
        <el-button
          type="primary"
          :disabled="$attrs.pargam.head===0?false:true"
          @click="addsaveClick"
        >保存新增</el-button>
        <el-button type="primary" @click="saveClick">保存返回</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="所属分类"
      :visible.sync="dialogVisible2"
      width="384px"
    >
      <div class="tree_box">
        <treehistory :datas="tableData" @handleNodeClick="handleNodeClicktree"></treehistory>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="Determine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tool from "@/utils/tool";
// :configData="configData"
import vPinyin from "@/utils/PyConversion.js";
export default {
  name: "IncreaseChange",
  data() {
    return {
      visible: this.show,
      search: {},
      notesVal: {
        BaseCode: "",
        FullName: "",
        Memo: "",
        ParentNo: "",
        ParentNos: 0,
        PyNo: ""
      },
      count_data: {},
      pageConfigData: {},
      tableData: [], //table表格数据
      configData: this.ConfigData,
      dialogVisible2: false,
      tableUnitPrice: false, // 分类是否显示
      searchData: {},
      ingexs: 0
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    ConfigData: Array
  },
  methods: {
    // 点击出入库
    clicknative(index) {
      this.ingexs = index;
    },
    // 点击分类确定
    Determine() {
      this.notesVal.ParentNo = this.search.label;
      this.notesVal.ParentNos = this.search.id;
      this.dialogVisible2 = false;
    },
    handleNodeClicktree(data) {
      this.search = data;
    },
    // 双击输入框
    ChoiceClick(FillType) {},
    clickclose(data, fieldData, FillType) {
      if (FillType == 0) {
        this.dialogVisible2 = true;
      }
    },
    // 按上键
    upkey(data, index, length) {
      if (index != 0 && index - 1 != -1) {
        // for (let i = index - 1; i < length; i--) {
        if (this.$refs.figData[index - 1].disabled == false) {
          this.$refs.figData[index - 1].$refs.input.focus();
          return;
        }
        // }
      }
    },
    // 回车回调
    nextFocus(data, index, FillType) {
      let rowindex = index + 1;
      if (FillType != 0) {
        for (let i = rowindex; i < this.count_data.All; i++) {
          if (this.$refs.figData[i].disabled == false) {
            this.ingexs = i;
            this.$refs.figData[i].$refs.input.focus();
            return;
          }
        }
      } else {
        if (data == "") {
          this.dialogVisible2 = true;
        } else {
          for (let i = rowindex; i < this.count_data.All; i++) {
            if (this.$refs.figData[i].disabled == false) {
              this.ingexs = i;
              this.$refs.figData[i].$refs.input.focus();
              return;
            }
          }
        }
      }
    },
    // 展开的回调
    opendialog() {
      if (this.$attrs.pargam.head == 0) {
        this.BaseCodedata();
        setTimeout(() => {
          this.notesVal.ParentNos = this.$attrs.pargam.ParentNos;
          this.notesVal.ParentNo = this.$attrs.pargam.ParentNo;
          this.$refs.figData[0].$refs.input.focus();
        }, 200);
      } else if (this.$attrs.pargam.head == 1) {
        this.notesVal = this.$attrs.Warehouse;
        setTimeout(() => {
          this.$refs.figData[0].$refs.input.focus();
        }, 200);
      }
    },
    // 分类回填
    chooseBackUnitPrice(row) {},
    // 初始❀输入框信息
    open() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        Model: this.$attrs.pargam.Model
      };
      this.request
        .post("/index/Settings/get_basic_table_fields", {
          jparams: JSON.stringify(params)
        })
        .then(res => {
          this.pageConfigData = res.data;
          this.count_data = res.count_data;
          this.distinctObj(res.data);
        });
    },
    // 初始化数据 分类
    InitTable() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid") //用户凭证
      };
      this.request
        .post(this.searchData.url1, {
          jparams: JSON.stringify(params)
        })
        .then(res => {
          this.tableData = res.tree;
        });
    },
    // 获取 编号
    BaseCodedata() {
      let params = {
        user_id: tool.getLocal("userid"), //用户id
        session_id: tool.getLocal("sessionid"), //用户凭证
        table: this.$attrs.pargam.Model,
        ParentNo: this.$attrs.pargam.ParentNos
      };
      this.request
        .post(this.searchData.url2, {
          jparams: JSON.stringify(params)
        })
        .then(res => {
          this.notesVal.BaseCode = res.BaseCode;
        });
    },
    // 判断是哪个页面进入
    searchClicks(field) {
      switch (field) {
        case "Stock":
          this.searchData = {
            title: "仓库",
            url1: "/index/Stock/getlist", // 获取 tree
            url2: "/index/common/get_basecode", // 获取编号
            url3: "/index/Stock/add", // 新增
            url4: "/index/Stock/updateone", // 修改
            classify: "Stock"
          };
          break;
        case "Goods":
          this.searchData = {
            title: "商品",
            url1: "/index/Goods/getlist", // 获取 tree
            url2: "/index/Goods/getall", // 获取编号
            url3: "/index/Goods/add", // 新增
            url4: "/index/Goods/updateone", // 修改
            classify: "Goods"
          };
          break;
        default:
          break;
      }
    },
    gasaa() {
      let fafa = {};
      switch (this.$attrs.pargam.Model) {
        case "Stock":
          fafa = {
            BaseCode: "",
            FullName: "",
            Memo: "",
            ParentNo: "",
            ParentNos: 0,
            PyNo: ""
          };
          break;
        default:
          break;
      }
      return fafa;
    },
    // 遍历 表头生成data对象 接收参数
    distinctObj(numberArr) {
      numberArr.A.map((item, value) => {
        if (item.Key == "ParentNo") {
          this.notesVal.ParentNo = "";
          this.notesVal.ParentNos = 0;
        } else {
          this.notesVal[item.Key] = "";
        }
      });
      numberArr.B.map((item, value) => {
        if (item.Key == "ParentNo") {
          this.notesVal.ParentNo = "";
          this.notesVal.ParentNos = 0;
        } else {
          this.notesVal[item.Key] = "";
        }
      });
      numberArr.C.map((item, value) => {
        if (item.Key == "ParentNo") {
          this.notesVal.ParentNo = "";
          this.notesVal.ParentNos = 0;
        } else {
          this.notesVal[item.Key] = "";
        }
      });
    },
    // 关闭弹出框前回调
    closeDialog() {
      this.$emit("update:show", false);
      this.notesVal = this.gasaa();
    },
    // 数据改变回填值
    dateChange(data, fieldData) {
      this.notesVal[fieldData] = data[0];
      this.notesVal.PyNo = vPinyin.makePy(this.notesVal.FullName);
    },
    Sentenceblank() {
      let flag = false;
      switch (this.$attrs.pargam.Model) {
        case "Stock":
          if (this.notesVal.FullName != "" && this.notesVal.BaseCode != "") {
            flag = true;
          } else {
            flag = false;
          }
          break;
        default:
          break;
      }
      return flag;
    },
    // 连续新增
    addsaveClick() {
      if (this.Sentenceblank()) {
        if (!tool.Buttonclick()) {
          return;
        }
        let params = {
          user_id: tool.getLocal("userid"), //用户id
          session_id: tool.getLocal("sessionid"), //用户凭证
          ParentNo: this.notesVal.ParentNos, //该仓库的父级仓库Id
          BaseCode: this.notesVal.BaseCode, //用户编号
          FullName: this.notesVal.FullName, //仓库全名
          Name: this.notesVal.FullName, //仓库简名
          Memo: this.notesVal.Memo, //备注
          PyNo: this.notesVal.PyNo,
          IsDir: 0
        };
        this.request
          .post(this.searchData.url3, { jparams: JSON.stringify(params) })
          .then(res => {
            let { status, description } = res;
            if (status == 0) {
              this.$message({
                showClose: true,
                message: description,
                type: "success"
              });
              let a = this.notesVal.ParentNos; //该仓库的父级仓库Id
              let b = this.notesVal.ParentNo; //该仓库的父级仓库Id
              this.notesVal = this.gasaa();
              this.notesVal.ParentNos = a; //该仓库的父级仓库Id
              this.notesVal.ParentNo = b; //该仓库的父级仓库Id
              this.BaseCodedata();
            } else {
              this.$message({
                showClose: true,
                message: description,
                type: "warning"
              });
            }
          });
      }
    },
    // 新增返回
    saveClick() {
      if (this.Sentenceblank()) {
        if (!tool.Buttonclick()) {
          return;
        }
      }
      // this.visible = false;
    }
  },
  mounted() {
    this.searchClicks(this.$attrs.pargam.Model);
    this.InitTable();
    this.open();
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    dialogVisible2: {
      handler: function(newVal, oldVal) {
        if (!newVal) {
          this.$refs.figData[this.ingexs + 1].$refs.input.focus();
        }
      }
    },
    notesVal: {
      handler: function(newVal, oldVal) {}
    }
  }
};
</script>

<style lang="less" scoped>
.IncreaseChange_box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.IncreaseChange_box_footer {
  display: flex;
  justify-content: flex-end;
}
/deep/ .el-dialog__body {
  padding: 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.sty_rowinputw {
  width: 48%;
  margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/IncreaseChange/IncreaseChange.vue